//
// Bridge between the axios layer (client/lib/api/index.js) and the redux
// store. The interceptor cannot import the store (the store's sagas import
// the api), so client/index.js registers a handler once the store exists and
// the interceptor calls it when the server rejects the stored credential.
//
type AuthInvalidatedHandler = () => void

let handler: AuthInvalidatedHandler | null = null

export const registerAuthInvalidatedHandler = (fn: AuthInvalidatedHandler): void => {
  handler = fn
}

export const unregisterAuthInvalidatedHandler = (): void => {
  handler = null
}

export const notifyAuthInvalidated = (): void => {
  handler?.()
}
